/**
 * Auth token access that works whether the user chose "Remember me"
 * (token in localStorage) or a session-only login (token in sessionStorage).
 */
export const getToken = () =>
  localStorage.getItem('token') || sessionStorage.getItem('token');

export const getUserId = () =>
  localStorage.getItem('userId') || sessionStorage.getItem('userId');
